'use client';

import { CheckCircleRounded } from '@mui/icons-material';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from '@mui/material';
import type { FC } from 'react';

type Props = {
  name: string | undefined;
  redirectTo: string | undefined;
  order?: number;
  disabled?: boolean;
};

export const CustomItem: FC<Props> = (props: Props) => {
  const { name, redirectTo, order = 3, disabled = false } = props;

  if (!name || !redirectTo) {
    return null;
  }

  return (
    <MenuItem
      component="a"
      href={redirectTo}
      target="_blank"
      sx={{ order, paddingY: 2 }}
      disabled={disabled}
    >
      <ListItemIcon sx={{ minWidth: 'auto' }}>
        <CheckCircleRounded color="primary" />
      </ListItemIcon>
      <ListItemText sx={{ flex: 1 }}>
        <Typography display="inline">{name}</Typography>
      </ListItemText>
    </MenuItem>
  );
};
